define('areas/shopitemtemplate/commands/editshopitemtemplatecommand',["require", "exports", "services/navigator"], function (require, exports, Navigator) {
    "use strict";
    var EditShopItemTemplateCommand = (function () {
        function EditShopItemTemplateCommand() {
        }
        EditShopItemTemplateCommand.prototype.execute = function (template) {
            Navigator.navigateTo("shopitemtemplate", "edit", "/template", null, [
                { key: "memberType", value: template.memberType },
                { key: "id", value: template.rowKey }
            ]);
        };
        return EditShopItemTemplateCommand;
    }());
    return EditShopItemTemplateCommand;
});

